import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const CheckListTable = ({ checklistItems = [] }) => {
  // 🔥 Calculate total
  const totalCost = checklistItems.reduce(
    (sum, item) => sum + (item.price || 0),
    0
  );

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>No</strong></TableCell>
            <TableCell><strong>Product Name</strong></TableCell>
            <TableCell align="right"><strong>Price</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {checklistItems.map((item, index) => (
            <TableRow key={item?._id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{item?.item?.en}</TableCell>
              <TableCell align="right">S$ {item?.price}</TableCell>
            </TableRow>
          ))}

          {/* 🔥 Total Row */}
          <TableRow>
            <TableCell colSpan={2} align="right">
              <strong>Total</strong>
            </TableCell>
            <TableCell align="right">
              <strong>S$ {totalCost}</strong>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CheckListTable;
